<!--  -->
<template>
  <div class="myplan-circle-box">
    <div v-if="progressData.sum">
    <i-circle
        :size="210"
        :trail-width="4"
        :stroke-width="5"
        :percent="perecentData"
        trail-color="rgba(255,255,255,.29)"
        :stroke-color="strokeColor">
        <div class="demo-i-circle-custom">
            <span class="left-num">{{progressData.finishCount}}/{{progressData.sum}}</span>
            <span class="middle-line"></span>
            <span class="right-num">{{Number(progressData.sum) === 0?0:perecentDataOld}}%</span>
        </div>
    </i-circle>
    </div>
  </div>
</template>
<script>
import { planQueryInfoPhasesList } from '@/api/data-myplan'
export default {
  name: '',
  components: {},
  data () {
    return {
      progressData: {
        finishCount: 0,
        sum: 0
      },
      strokeColor: '#3BC5FE'
    }
  },
  computed: {
    perecentData () {
      let num = Number(((this.progressData.finishCount / this.progressData.sum) * 100).toFixed(0)) > 100 ? 100 : Number(((this.progressData.finishCount / this.progressData.sum) * 100).toFixed(0))
      return num
    },
    perecentDataOld () {
      let num = Number(((this.progressData.finishCount / this.progressData.sum) * 100).toFixed(0))
      return num
    }
  },
  mounted () {
    this.planQueryInfoPhasesList()
  },
  methods: {
    planQueryInfoPhasesList () {
      planQueryInfoPhasesList().then(res => {
        if (res.code === 0) {
          this.progressData.finishCount = Number(res.data.finishCount)
          this.progressData.sum = Number(res.data.sum)
          this.strokeColor = res.data.degree ? res.data.degree.color : '#3BC5FE'
        }
      })
    }
  }
}
</script>
<style lang='less' scoped>
.demo-i-circle-custom{
  width:208px;
  height:208px;
  font-weight: bold;
  color: #ffffff;
  line-height: 24px;
  position:relative;
  .left-num {
    font-size: 22px;
    position:absolute;
    left:14%;
    top:28%;
  }
  .right-num{
    position:absolute;
    bottom:30%;
    right:14%;
    font-size: 30px;
  }
  .middle-line{
    position: absolute;
    left:20%;
    top:49%;
    width:122px;
    height:1px;
    background-color:rgba(255,255,255,.15);
    transform: rotate(115deg);
  }
}
</style>
